import AccountAdminService from '@/api/admin/accountAdmin.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    statuses: [],
    editWithdrawRequest: {
      loading: true,
      type: 0,
      info: {},
    },
    withdrawModel: {},
  },
  getters: {
    allWithdraws: state => state.table,
    editWithdrawRequest: state => state.editWithdrawRequest,
    getWithdrawModel: state => state.withdrawModel,
  },
  actions: {
    async getWithdraws({ commit }) {
      const withdraws = await AccountAdminService.getWithdraws()
      commit('SET_WITHDRAAWS', withdraws)
      commit('SET_TOTALRECORDS', withdraws.totalRecords)
      commit('SET_WITHDRAW_MODEL', withdraws)
    },
    async getFilteredWithdraws({ commit }, filter) {
      const withdraws = await AccountAdminService.getFilteredWithdraws(filter)
      commit('SET_WITHDRAAWS', withdraws)
      commit('SET_TOTALRECORDS', withdraws.totalRecords)
      commit('SET_WITHDRAW_MODEL', withdraws)
    },
  },
  mutations: {
    SET_WITHDRAAWS(state, withdraws) {
      state.table.rows = withdraws.withdrawRequests
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_WITHDRAW_REQUEST(state, filter) {
      state.editWithdrawRequest.info = filter.data
      state.editWithdrawRequest.type = filter.type
      state.editWithdrawRequest.loading = false
    },
    SET_WITHDRAW_MODEL(state, withdrawModel) {
      state.withdrawModel = withdrawModel
    },
  },
}
